import { PublicClientApplication } from '@azure/msal-browser';
import { environment } from '@/config/environment';

/** Delegated scope for direct-to-storage access from the portal. */
export const STORAGE_SCOPE = 'https://storage.azure.com/user_impersonation';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.azureAd.clientId,
    authority: `https://login.microsoftonline.com/${environment.azureAd.tenantId}`,
    redirectUri: '/portal',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
});

/**
 * Acquire an access token for Azure Storage using the signed-in admin's
 * account — silent first, redirect on consent/expiry. Used by the blob
 * stores in test/live (local dev uses an Azurite SAS instead).
 */
export async function getStorageToken(): Promise<{ token: string; expiresOnTimestamp: number }> {
  const account = msalInstance.getAllAccounts()[0];
  if (!account) {
    throw new Error('Not signed in');
  }
  try {
    const result = await msalInstance.acquireTokenSilent({
      scopes: [STORAGE_SCOPE],
      account,
    });
    return {
      token: result.accessToken,
      expiresOnTimestamp: result.expiresOn?.getTime() ?? Date.now() + 55 * 60 * 1000,
    };
  } catch {
    await msalInstance.acquireTokenRedirect({ scopes: [STORAGE_SCOPE], account });
    throw new Error('Redirecting for storage consent');
  }
}
